module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Db-Fb-Ga-Hb-Ia 后背.844d28dd.png";